import type { PublicId } from 'flow/store/engine/types';
import { Operation } from '../../types';
import type { MergeDiffResult } from './types';

export function getIsMergeImpacted(
  mergeDiff: MergeDiffResult,
  publicId: PublicId,
) {
  const { added, modified, removed } = mergeDiff;
  return added.has(publicId) || modified.has(publicId) || removed.has(publicId);
}

/**
 * Returns the Operation (add/modify/remove) that the action with the given
 * publicId underwent in the merge diff, or null
 */
export function getMergeDiffOperation(
  mergeDiff: MergeDiffResult | null,
  publicId: PublicId,
): Operation | null {
  if (!mergeDiff) return null;
  if (mergeDiff.added.has(publicId)) return Operation.Add;
  if (mergeDiff.modified.has(publicId)) return Operation.Modify;
  if (mergeDiff.removed.has(publicId)) return Operation.Remove;
  return null;
}
